import { CellClickedEvent } from '@ag-grid-community/all-modules';
import React from 'react';

export const RowMenuButton: React.FC = () => (
    <button className="btn">
        <i className="material-icons">more_vert</i>
    </button>
)

export function handleRowMenuClick(ev: CellClickedEvent) {
    //Programatically displaying the context menu is not supported by the library, but this hack makes it work
    //It's possible that a future version of the library will break this
    //https://github.com/ag-grid/ag-grid-enterprise/issues/72
    const api: any = ev.api;
    api.contextMenuFactory.showMenu(ev.node, ev.column, ev.value, ev.event);
}